module.exports = __webpack_public_path__ + "img/企业用人观.f9a805e7.png";